import { createSlice } from "@reduxjs/toolkit";

// Helper to add/increment or decrement offers
const updateOffers = (state: any, action: any) => {
  const { offer, type } = action.payload;
  const arr = state.selectedOffers;
  const findIndex = arr.findIndex((o: any) => o.id === offer.id);
  if (findIndex >= 0) {
    // Offer already selected
    if (type === "add") {
      arr[findIndex].count += 1;
    } else if (type === "remove") {
      arr[findIndex].count -= 1;
      if (arr[findIndex].count <= 0) {
        arr.splice(findIndex, 1);
      }
    }
  } else if (type === "add") {
    arr.push({ ...offer, count: 1 });
  }
  return arr;
};

const offersSlice = createSlice({
  name: "offers",
  initialState: {
    selectedOffers: [], // Array of {id, title, image, price, count}
  },
  reducers: {
    updateOfferCount: (state, action) => {
      state.selectedOffers = updateOffers(state, action);
    },
    clearOffers: (state) => {
      state.selectedOffers = [];
    },
  },
});

export const { updateOfferCount, clearOffers } = offersSlice.actions;
export default offersSlice.reducer; 